import { Tag, Typography } from 'antd'
import { useOntology } from 'features/dynamicOntology'
import { FC } from 'react'
import styled from 'styled-components'

import {
  ExpressionType,
  FIELD_OPERATOR_META,
  FieldExpression,
  FieldOperator,
} from './MetricsPanelConfig'

const { Text } = Typography

const ExpressionContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  margin: 8px 0;
`

const BlockText = styled(Text)`
  display: block;
`

interface EquationVisualizationProps {
  expressions: ReadonlyArray<FieldExpression>
  title?: string
  currentGroup?: ReadonlyArray<FieldExpression>
}

const Field: FC<{ field: string }> = ({ field }) => {
  const { fields } = useOntology()
  return <Tag color='blue'>{fields[field]?.name ?? field}</Tag>
}

const Operation: FC<{ operation: FieldOperator }> = ({ operation }) => (
  <Tag color='gold'>{FIELD_OPERATOR_META[operation].symbol}</Tag>
)

const Group: FC<{ expressions: ReadonlyArray<FieldExpression> }> = ({
  expressions,
}) => (
  <>
    <Text strong>(</Text>
    <ExpressionList expressions={expressions} />
    <Text strong>)</Text>
  </>
)

const ExpressionList: FC<{ expressions: ReadonlyArray<FieldExpression> }> = ({
  expressions,
}) => (
  <>
    {expressions.map((expr, i) => {
      switch (expr.type) {
        case ExpressionType.FIELD:
          return <Field key={i} field={expr.field} />
        case ExpressionType.OPERATION:
          return <Operation key={i} operation={expr.operation} />
        case ExpressionType.GROUP:
          return <Group key={i} expressions={expr.expressions} />
      }
    })}
  </>
)

export const EquationVisualization: FC<EquationVisualizationProps> = ({
  expressions,
  title = 'Equation Preview',
  currentGroup,
}) => {
  return (
    <div>
      <BlockText strong>{title}</BlockText>
      <ExpressionContainer>
        {expressions.length > 0 || currentGroup !== undefined ? (
          <>
            <ExpressionList expressions={expressions} />
            {currentGroup !== undefined && (
              <>
                <Text strong>(</Text>
                <ExpressionList expressions={currentGroup} />
                <Text strong type='secondary'>
                  )
                </Text>
              </>
            )}
          </>
        ) : (
          <Text type='secondary' italic>
            No field expressions defined
          </Text>
        )}
      </ExpressionContainer>

      {currentGroup !== undefined && (
        <BlockText type='secondary'>
          Building group... Click &quot;End Group&quot; when finished.
        </BlockText>
      )}
    </div>
  )
}
